const {
	fillWithDomElements,
	fillWithDomElementsAll,
	setClass,
	addEventsTo,
	toggleMenuArias,
	getFocusablesFrom,
	trackDownload,
	disableStaticURL,
} = require('util/functions');

const { stuttering, default: onWidthResize } = require('util/onWidthResize');
const { DELAY_DEBOUNCE, CLASS_NO_DISPLAY } = require('util/consts');

const CLASS_CELL_CONTAINER = 'table-widget-ir--cell-container';
const CLASS_CELL = 'table-widget-ir--cell';
const CLASS_MORE_BUTTON = 'table-widget-ir--more-button';
const CLASS_COLLAPSING_BODY = 'table-widget-ir--collapsing-rows';
const CLASS_BUTTON_LABELS = 'table-widget-ir--button-label';
const CLASS_FOOTNOTED = 'footnoted';
const CLASS_FOOTNOTES = 'table-widget-ir--footnote';
const CLASS_ROWS = 'table-widget-ir--row';
const CLASS_FILE = 'table-widget-ir--file';
const CLASS_TITLE = 'table-widget-ir--title';

const CLASS_OPEN = 'open';
const CLASS_ACTIVE = 'active';
const CLASS_HIGHLIGHTED = 'highlighted';

const selectors = {
	moreButton: CLASS_MORE_BUTTON,
	collapsingBody: CLASS_COLLAPSING_BODY,
	mainTitle: CLASS_TITLE,
};
const selectorsAll = {
	buttonLabels: CLASS_BUTTON_LABELS,
	footnoted: CLASS_FOOTNOTED,
	footnotes: CLASS_FOOTNOTES,
	rows: CLASS_ROWS,
};

module.exports = {
	init() {
		fillWithDomElements(this, selectors);
		fillWithDomElementsAll(this, selectorsAll);
		this.checkShowMore();
		this.initGtm();
		if (this.collapsingBody) this.initCollapsing();
		this.initFootnotes();
	},
	initGtm() {
		const mainTitle = this.mainTitle?.innerText;
		const highlightColumnName = this.root.querySelector('th').innerText;
		const baseTitle = `${mainTitle}${
			mainTitle ? ' - ' : ''
		}${highlightColumnName}: `;
		this.root.addEventListener('click', ({ target }) => {
			if (!target.classList.contains(CLASS_FILE)) return;
			const { href } = target;
			const { innerText } = target.closest('tr').querySelector('td');
			trackDownload(baseTitle + innerText, href);
			disableStaticURL(target, 'download-disabled');
		});
	},
	//collapsing
	initCollapsing() {
		this.containers = this.collapsingBody.querySelectorAll(
			`.${CLASS_CELL_CONTAINER}`,
		);
		this.containersContents = this.collapsingBody.querySelectorAll(
			`.${CLASS_CELL}`,
		);

		this.initRows();
		this.moreButton.addEventListener('click', this.toggleMore.bind(this));

		onWidthResize(
			() => {
				this.processRowHeights();
				this.setCollapse(this.collapsed);
			},
			stuttering.DEBOUNCE,
			DELAY_DEBOUNCE,
		);
		this.collapsed = true;
	},
	initRows() {
		this.collapsingRows = [...this.collapsingBody.querySelectorAll('tr')].map(
			row => ({
				row,
				cells: row.querySelectorAll(`.${CLASS_CELL}`),
			}),
		);
		this.processRowHeights();
	},
	processRowHeights() {
		this.collapsingRows.forEach(row => {
			const { cells } = row;
			const heights = [...cells].map(cell => cell.offsetHeight);
			row.height = Math.max(...heights) + 'px';
		});
	},
	toggleMore() {
		this.setCollapse(!this.collapsed);
	},
	setCollapse(doesCollapse) {
		this.collapsed = doesCollapse;
		setClass(this.buttonLabels[0], this.collapsed, CLASS_ACTIVE);
		setClass(this.buttonLabels[1], !this.collapsed, CLASS_ACTIVE);
		setClass(this.collapsingBody, !doesCollapse, CLASS_OPEN);
		this.collapsingRows.forEach(({ height, row }) => {
			const newHeight = doesCollapse ? 0 : height;
			row.style.setProperty('--row-height', newHeight);
		});
		const focusablesInCollapsable = getFocusablesFrom(this.collapsingBody);
		toggleMenuArias(this.moreButton, focusablesInCollapsable, !doesCollapse);
		if (doesCollapse) getFocusablesFrom(this.root)[0].focus();
		else focusablesInCollapsable[0]?.focus();
	},

	//footnotes
	initFootnotes() {
		[
			[this.footnoted, this.footnotes],
			[this.footnotes, this.footnoted],
		].forEach(([buttonList, targetList]) => {
			buttonList.forEach((button, i) => {
				const target = targetList[i];

				addEventsTo(button, {
					mouseover: this.highlightFootnote.bind(this, target, true),
					mouseout: this.highlightFootnote.bind(this, target, false),
					click: this.goTo.bind(this, target),
				});
			});
		});
	},
	highlightFootnote(element, doesHighlight) {
		// if the element is a cell target the row instead of the element
		const target = element.classList.contains(CLASS_FOOTNOTES)
			? element
			: element.parentNode;
		setClass(target, doesHighlight, CLASS_HIGHLIGHTED);
	},
	goTo(target) {
		const isHidden = this.collapsed && this.collapsingBody.contains(target);
		if (isHidden) {
			this.setCollapse(false);
			this.containers[0].addEventListener(
				'transitionend',
				this.scrollTo.bind(this, target),
				{ once: true },
			);
		} else this.scrollTo(target);
	},
	scrollTo(element) {
		const nav = document.querySelector('.nav-layout');
		const padding = nav ? nav.offsetHeight : 0;
		if (window.scrollTo)
			window.scrollTo({
				top: window.pageYOffset + element.getBoundingClientRect().top - padding,
				behavior: 'smooth',
			});
	},
	checkShowMore() {
		this.visibleRowsCount = parseInt(this.root.dataset.visibleRows);
		if (this.visibleRowsCount >= this.rows.length) {
			this.moreButton.classList.add(CLASS_NO_DISPLAY);
		}
	},
};
